<template>
    <v-row no-gutters>
        <v-col>

            <!-- title card -->
            <v-row no-gutters align="center">
                <v-col cols="auto">
                    <component :is="'h' + (level + 2)" v-text="section.title" class="pr-4" />
                </v-col>
                <v-col cols="0">
                    <v-divider v-if="index > 0"></v-divider>
                </v-col>
            </v-row>
            <v-row no-gutters class="mt-4 mb-4">
                <v-col>
                    <p v-text="section.description" class="ma-0" style="opacity: 0.8; white-space: pre-line;" />
                </v-col>
            </v-row>

            <slot name="prepend-settingList">
            </slot>

            <!-- settings -->
            <slot name="settingList">
                <SettingRow v-for="setting in section.settingList" :key="section.key + setting.settingKey"
                    :setting="setting" :loaded="!isLoading && initiated" :fetchLoading="isLoading"
                    @debounceSave="debouncedAutoSave()" @instantSave="saveSettings">
                </SettingRow>
            </slot>

            <slot name="append-settingList">
            </slot>

            <!-- nested sections -->
            <slot name="subSections">
                <component v-for="subSection in section.subSections" :key="subSection.key"
                    :is="subSection.component || 'SettingsSection'" :section="subSection" :index="0" :level="level + 1"
                    :isLoading="isLoading" :initiated="initiated" @debounceSave="debouncedAutoSave()"
                    @instantSave="saveSettings">
                </component>
            </slot>

        </v-col>
    </v-row>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import Section from "./Section.js"
import SettingRow from './SettingRow.vue';
import SettingsMixin from './SettingsMixin.js';
import TimeRoundingSection from "./TimeRoundingSection.vue";

export default {
    name: "SettingsSection",
    props: {
        section: Section,
        index: Number,
        level: Number,
        isLoading: Boolean,
        initiated: Boolean,
    },
    components: {
        SettingRow,
        TimeRoundingSection,
    },
    mixins: [clientAPI, SettingsMixin],

    data() {
        return {};
    },

    methods: {
        saveSettings(settingsArr) {
            this.$emit('instantSave', settingsArr)
        },

        debouncedAutoSave() {
            this.$emit('debounceSave')
        },
    },

    computed: {},

    watch: {},
};
</script>


<style lang="scss" scoped></style>